/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The LoginRequest model module.
* @module model/LoginRequest
* @version 2020-12-7
*/
export default class LoginRequest {
    /**
    * Constructs a new <code>LoginRequest</code>.
    * ログインリクエスト
    * @alias module:model/LoginRequest
    * @class
    * @param companyId {Number} 会社ID
    * @param loginKey {String} ログインキー
    * @param password {String} パスワード
    */

    constructor(companyId, loginKey, password) {
        
        
        this['companyId'] = companyId;
        this['loginKey'] = loginKey;
        this['password'] = password;
        
    }

    /**
    * Constructs a <code>LoginRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LoginRequest} obj Optional instance to populate.
    * @return {module:model/LoginRequest} The populated <code>LoginRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LoginRequest();
                        
            
            if (data.hasOwnProperty('companyId')) {
                obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Number');
            }
            if (data.hasOwnProperty('loginKey')) {
                obj['loginKey'] = ApiClient.convertToType(data['loginKey'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
        }
        return obj;
    }

    /**
    * 会社ID
    * @member {Number} companyId
    */
    'companyId' = undefined;
    /**
    * ログインキー
    * @member {String} loginKey
    */
    'loginKey' = undefined;
    /**
    * パスワード
    * @member {String} password
    */
    'password' = undefined;




}
